"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRefNumber = newRefNumber;
function newRefNumber() {
    return generateReferenceNumber();
}
function generateReferenceNumber() {
    // Generate random base36 string with 4 chars
    let randString = "";
    for (let i = 0; i < 4; i++) {
        const a = Math.floor(Math.random() * (35 - 0 + 1)) + 0;
        const c = toBase36Char(a);
        randString += c;
    }
    const dateString = convertToBase36(generateUniqueDateNumberOnSecondLevel(new Date()));
    return dateString + randString;
}
function generateUniqueDateNumberOnSecondLevel(date) {
    // Use 00-63 for the year since we expect the lifetime of the reference number to be less than 64 years
    // Year needs 6 bits (63 dec = 111111 bin) shift = 32-6 = 26
    // Month needs 4 bits (12 dec = 1100 bin) shift = 32-(6+4) = 22
    // Day needs 5 bits (31 dec = 11111 bin) shift = 32-(6+4+5) = 15
    // Hour needs 5 bits (23 dec = 10111 bin) shift = 32-(6+4+5+5) = 10
    // Minute needs 6 bits (60 dec = 111100 bin) shift = 32-(6+4+5+5+6) =  6
    // Second needs 6 bits (60 dec = 111100 bin)
    // Total 6+4+5+5+6+6=32 bits
    const year = Math.abs(Math.floor((date.getUTCFullYear() << 26) & 0xfc000000));
    const month = Math.abs(Math.floor((date.getUTCMonth() << 22) & 0x3c00000));
    const day = Math.abs(Math.floor((date.getUTCDate() << 15) & 0x3e0000));
    const hour = Math.abs(Math.floor((date.getUTCHours() << 10) & 0x1f000));
    const minute = Math.abs(Math.floor((date.getUTCMinutes() << 6) & 0xfc0));
    const second = Math.abs(Math.floor((date.getUTCSeconds() << 0) & 0x3f));
    const total = Math.abs(Math.floor(year | month | day | hour | minute | second));
    return total;
}
function convertToBase36(i) {
    const BASE = 36;
    let result = "";
    let remainder;
    while (i > 0) {
        remainder = Math.floor(i % BASE);
        i = Math.floor(i / BASE);
        result = toBase36Char(remainder) + result;
    }
    return result;
}
function toBase36Char(value) {
    if (value <= 9) {
        return value.toString();
    }
    else {
        return String.fromCharCode(65 + (value - 10));
    }
}
//# sourceMappingURL=refnumber.js.map